import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  Loading: false,
};

const workflowLoaderSlice = createSlice({
  name: "workflowLoader",

  initialState,
  reducers: {
    setWorkflowLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.Loading = payload;
    },
    resetWorkflowLoader: (state: any) => {
      state.Loading = false;
    },
  },
});

export const { setWorkflowLoader, resetWorkflowLoader } =
  workflowLoaderSlice.actions;

export default workflowLoaderSlice.reducer;
